var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar4Week(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0625 0.5C3.30412 0.5 3.5 0.695875 3.5 0.9375V1.375H10.5V0.9375C10.5 0.695875 10.6959 0.5 10.9375 0.5C11.1791 0.5 11.375 0.695875 11.375 0.9375V1.375H12.25C13.2165 1.375 14 2.1585 14 3.125V12.75C14 13.7165 13.2165 14.5 12.25 14.5H1.75C0.783502 14.5 0 13.7165 0 12.75V3.125C0 2.1585 0.783502 1.375 1.75 1.375H2.625V0.9375C2.625 0.695875 2.82088 0.5 3.0625 0.5ZM1.75 2.25C1.26675 2.25 0.875 2.64175 0.875 3.125V4H13.125V3.125C13.125 2.64175 12.7332 2.25 12.25 2.25H1.75ZM13.125 4.875H0.875V12.75C0.875 13.2332 1.26675 13.625 1.75 13.625H12.25C12.7332 13.625 13.125 13.2332 13.125 12.75V4.875Z",
    fill: "#8083A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.0625C9.625 6.82088 9.82088 6.625 10.0625 6.625H10.9375C11.1791 6.625 11.375 6.82088 11.375 7.0625V7.9375C11.375 8.17912 11.1791 8.375 10.9375 8.375H10.0625C9.82088 8.375 9.625 8.17912 9.625 7.9375V7.0625Z",
    fill: "#8083A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.0625C7 6.82088 7.19588 6.625 7.4375 6.625H8.3125C8.55412 6.625 8.75 6.82088 8.75 7.0625V7.9375C8.75 8.17912 8.55412 8.375 8.3125 8.375H7.4375C7.19588 8.375 7 8.17912 7 7.9375V7.0625Z",
    fill: "#8083A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.6875C5.25 9.44588 5.44588 9.25 5.6875 9.25H6.5625C6.80412 9.25 7 9.44588 7 9.6875V10.5625C7 10.8041 6.80412 11 6.5625 11H5.6875C5.44588 11 5.25 10.8041 5.25 10.5625V9.6875Z",
    fill: "#8083A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 9.6875C2.625 9.44588 2.82088 9.25 3.0625 9.25H3.9375C4.17912 9.25 4.375 9.44588 4.375 9.6875V10.5625C4.375 10.8041 4.17912 11 3.9375 11H3.0625C2.82088 11 2.625 10.8041 2.625 10.5625V9.6875Z",
    fill: "#8083A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar4Week);
export default __webpack_public_path__ + "static/media/calendar4-week.fcd3c99b.svg";
export { ForwardRef as ReactComponent };